import React from 'react'
import { Link } from 'react-router-dom'
import { CiClock2, CiMail, } from 'react-icons/ci'
import { PiPhoneThin } from 'react-icons/pi';
import { motion } from 'framer-motion'
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/css';
import 'swiper/css/scrollbar';
import "swiper/css/pagination";
import { Autoplay } from 'swiper/modules';

import image from './../../assets/home/main.png'

import section3_image from './../../assets/home/abstract-background-with-low-poly-design 1.png'
import icon_section3 from './../../assets/home/Icon.png'
import section3 from './../../assets/home/Image.png'

import project_1 from './../../assets/home/work-1.png'
import project_2 from './../../assets/home/work-2.png'
import project_3 from './../../assets/home/work-3.png'
import project_4 from './../../assets/home/work-4.png'
import project_5 from './../../assets/home/work-5.png'

import sponser_1 from './../../assets/home/sponser_1.jpg'
import sponser_2 from './../../assets/home/sponser_2.jpg'
import sponser_3 from './../../assets/home/sponser_3.jpg'
import sponser_4 from './../../assets/home/sponser_4.jpg'

import studio_green_logo from './../../assets/home/Logo-studio-green.svg'
import norto_logo from './../../assets/home/Logo-Norto.svg'
import out_of_the_stand_logo from './../../assets/home/Logo-Out Of The Sand Box.svg'
import points_one_logo from './../../assets/home/Logo-points-one.svg'

import abuDubaiImg from "./../../assets/home/abu-dhabi-seascape-with-skyscrapers (1) 2.png"

import blog_1 from "./../../assets/home/blog_1.png"
import blog_2 from "./../../assets/home/blog_2.png"
import blog_3 from "./../../assets/home/blog_3.png"


const Home = () => {
    return (
        <div className="home">
            <div className="section_1 min-h-[100vh] bg-cover bg-no-repeat flex items-center" style={{ backgroundImage: `url(${image})` }}>
                <div className="box flex items-center w-5/6 lg:w-4/6 m-auto">
                    <motion.div
                        initial={{
                            y: -200,
                            opacity: 0
                        }}
                        whileInView={{
                            y: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }}
                        className="text flex flex-col md:w-3/5">
                        <h1 className='text-4xl md:text-5xl lg:text-6xl font-bold'>
                            Embracing trust by delivering value
                        </h1>
                        <p className="md:text-sm text-xs my-3 font-Krub">
                            In augue ligula, feugiat ut nulla consequat. Ut est lacus, molestie in arcu no, iaculis vehicula ipsum. Nunc faucibus, nisl id dapibus finibus, enim diam interdum nulla, sed laoreet risus lectus.
                        </p>
                        <button className='bg-main-light w-fit text-sm font-krub text-white py-3 px-6 md:py-5 md:px-11 mt-2'>Explore More</button>
                    </motion.div>
                </div>
            </div>
            <div className="section_2 py-24">
                <div className="md:md:w-4/6 px-8 md:px-0 m-auto grid grid-cols-3 gap-6">
                    <motion.div
                        initial={{
                            x: -200,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }}
                        className="what-we-do col-span-3 lg:col-span-1 text-dark">
                        <span className="bg-gray-light p-1 px-2 border-l-4 border-l-main-light text-sm ">What We Do</span>
                        <h2 className="text-3xl md:text-4xl font-semibold my-2">Safe & Reliable Technology Solutions</h2>
                    </motion.div>
                    <motion.div
                        initial={{
                            y: -200,
                            opacity: 0
                        }}
                        whileInView={{
                            y: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }}
                        className="info grid col-span-3 lg:col-span-2 grid-cols-1 xxs:grid-cols-2 gap-y-5 xxs:gap-y-5 sm:gap-5 md:gap-10">
                        <div className="box border-l px-5">
                            <h5 className="text-2xl">First Title</h5>
                            <p className="text-sm font-Krub text-gray">Following the quality of our service thus having gained trust of our many clients.</p>
                        </div>
                        <div className="box border-l px-5">
                            <h5 className="text-2xl">Second Title</h5>
                            <p className="text-sm font-Krub text-gray">Following the quality of our service thus having gained trust of our many clients.</p>
                        </div>
                        <div className="box border-l px-5">
                            <h5 className="text-2xl">Third Title</h5>
                            <p className="text-sm font-Krub text-gray">Following the quality of our service thus having gained trust of our many clients.</p>
                        </div>
                        <div className="box border-l px-5">
                            <h5 className="text-2xl">Fourth Title</h5>
                            <p className="text-sm font-Krub text-gray">Following the quality of our service thus having gained trust of our many clients.</p>
                        </div>
                    </motion.div>
                </div>
            </div>
            <div className="section_3 min-h-[80vh] my-10 relative overflow-hidden">
                <div className="">
                    <div className="absolute top-0 left-0 right-0 w-full -z-10" >
                        <img src={section3_image} alt="" className="w-full" />
                    </div>
                    <div className="content bg-white w-5/6 mt-10 md:mt-20 lg:w-5/6 m-auto px-8 pt-8 lg:px-16 lg:pt-16 shadow-md">
                        <div className="text grid grid-cols-2 gap-10 md:gap-10 lg:gap-20">
                            <motion.div
                                initial={{
                                    x: -200,
                                    opacity: 0
                                }}
                                whileInView={{
                                    x: 0,
                                    opacity: 1
                                }}
                                transition={{
                                    duration: 0.5
                                }}
                                viewport={{
                                    once: true
                                }}
                                className="col-span-2 md:col-span-1 text-dark ">
                                <span className="bg-gray-light p-1 px-2 border-l-4 border-l-main-light text-sm ">Why Us</span>
                                <h2 className="text-3xl font-semibold my-2">Title Text Title Text </h2>
                                <p className="font-Krub text-sm font-medium leading-6 text-gray">Leverage agile frameworks to provide a robust synopsis for strategy foster collaborative thinking to further the overall value proposition.
                                    <br />
                                    <br />
                                    Organically grow the holistic world view of disruptive innovation via workplace diversity and empowerment.
                                </p>
                                <div className="flex items-center gap-4 my-4">
                                    <img src={icon_section3} alt="" className='h-10' />
                                    <p className="text-xl sm:text-2xl text-dark">Example</p>
                                </div>
                                <div className="flex items-center gap-4 my-4">
                                    <img src={icon_section3} alt="" className='h-10' />
                                    <p className="text-xl sm:text-2xl text-dark">Example</p>
                                </div>
                            </motion.div>
                            <motion.div initial={{
                                y: -200,
                                opacity: 0
                            }}
                                whileInView={{
                                    y: 0,
                                    opacity: 1
                                }}
                                transition={{
                                    duration: 0.5
                                }}
                                viewport={{
                                    once: true
                                }} className="col-span-2 md:col-span-1 image w-fit m-auto">
                                <div className="">
                                    <img src={section3} alt="" className="" />
                                </div>
                            </motion.div>
                            {/* <motion.div initial={{
                                y: -200,
                                opacity: 0
                            }}
                                whileInView={{
                                    y: 0,
                                    opacity: 1
                                }}
                                transition={{
                                    duration: 0.5
                                }}
                                viewport={{
                                    once: true
                                }} className="col-span-5 md:col-span-2 image relative w-fit m-auto">
                                <div className="">
                                    <img src={section3} alt="" className="" />
                                </div>
                                <div className="small_img p-5 w-1/2 absolute -left-1/3 -bottom-1/2 transform -translate-y-1/2 translate-x-1/3 bg-white">
                                    <img src={section3} alt="" />
                                </div>
                            </motion.div> */}
                        </div>
                    </div>
                </div>
            </div>
            <div className="testimonials pb-10">
                <div className="sm:w-4/6 m-auto grid lg:grid-cols-2 grid-cols-1">
                    <motion.div
                        initial={{
                            x: -200,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }} className="col-span-1 flex gap-3 items-center justify-center px-4 py-10 md:p-10 border-2 lg:border-l-0">
                        <p className="text-3xl md:text-5xl text-dark font-semibold ">1294</p>
                        <div className="w-4 h-4 bg-main-light"></div>
                        <p className="text-lg md:text-xl leading-5">Delivered Projects</p>
                    </motion.div>
                    <motion.div
                        initial={{
                            x: 200,
                            opacity: 0
                        }}
                        whileInView={{
                            x: 0,
                            opacity: 1
                        }}
                        transition={{
                            duration: 0.5
                        }}
                        viewport={{
                            once: true
                        }} className="col-span-1 flex gap-3 items-center justify-center px-4 py-10 md:p-10 border-2 lg:border-r-0">
                        <p className="text-3xl md:text-5xl text-dark font-semibold ">3594</p>
                        <div className="w-4 h-4 bg-main-light"></div>
                        <p className="text-lg md:text-xl leading-5">Satisfied Clients</p>
                    </motion.div>
                </div>
            </div>
            <div className="section_4 work py-10 relative min-h-[20vh]">
                <div className="w-5/6 m-auto z-10 left-0 right-0">
                    <h2 className="text-3xl mb-5 font-semibold text-center uppercase text-dark">Title</h2>
                    <Swiper
                        breakpoints={{
                            280: {
                                width: 280,
                                slidesPerView: 1,
                            },
                            375: {
                                width: 375,
                                slidesPerView: 1,
                            },
                            576: {
                                width: 576,
                                slidesPerView: 2,
                            },
                            768: {
                                width: 768,
                                slidesPerView: 3,
                            },
                            1024: {
                                width: 1024,
                                slidesPerView: 4,
                            },
                        }}
                        modules={[Autoplay]}
                        spaceBetween={30}
                        slidesPerView={6}
                        autoplay={{
                            delay: 2000,
                            disableOnInteraction: false,
                        }}
                        pagination={{ clickable: true }}
                        className=" h-auto cursor-pointer select-none m-auto flex justify-center items-center">
                        <SwiperSlide className='m-auto'>
                            <div className="col-span-1 relative w-fit">
                                <div className="layer bg-gradient-to-t from-black via-transparent to-transparent w-full h-full absolute"></div>
                                <img src={project_1} alt="" className="w-full" />
                                <div className="headline absolute p-5 bottom-0">
                                    <h5 className="text-white text-xl leading-6 font-medium">Headline</h5>
                                    <h6 className="text-gold text-sm font-Krub font-medium">Sub-headline</h6>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className='m-auto'>
                            <div className="col-span-1 relative w-fit">
                                <div className="layer bg-gradient-to-t from-black via-transparent to-transparent w-full h-full absolute"></div>
                                <img src={project_2} alt="" className="w-full" />
                                <div className="headline absolute p-5 bottom-0">
                                    <h5 className="text-white text-xl leading-6 font-medium">Headline</h5>
                                    <h6 className="text-gold text-sm font-Krub font-medium">Sub-headline</h6>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className='m-auto'>
                            <div className="col-span-1 relative w-fit">
                                <div className="layer bg-gradient-to-t from-black via-transparent to-transparent w-full h-full absolute"></div>
                                <img src={project_3} alt="" className="w-full" />
                                <div className="headline absolute p-5 bottom-0">
                                    <h5 className="text-white text-xl leading-6 font-medium">Headline</h5>
                                    <h6 className="text-gold text-sm font-Krub font-medium">Sub-headline</h6>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className='m-auto'>
                            <div className="col-span-1 relative w-fit">
                                <div className="layer bg-gradient-to-t from-black via-transparent to-transparent w-full h-full absolute"></div>
                                <img src={project_4} alt="" className="w-full" />
                                <div className="headline absolute p-5 bottom-0">
                                    <h5 className="text-white text-xl leading-6 font-medium">Headline</h5>
                                    <h6 className="text-gold text-sm font-Krub font-medium">Sub-headline</h6>
                                </div>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className='m-auto'>
                            <div className="col-span-1 relative w-fit">
                                <div className="layer bg-gradient-to-t from-black via-transparent to-transparent w-full h-full absolute"></div>
                                <img src={project_5} alt="" className="w-full" />
                                <div className="headline absolute p-5 bottom-0">
                                    <h5 className="text-white text-xl leading-6 font-medium">Headline</h5>
                                    <h6 className="text-gold text-sm font-Krub font-medium">Sub-headline</h6>
                                </div>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                    <div className="flex justify-center mt-5">
                        <Link to='/projects' className='bg-main w-fit text-sm font-krub text-white py-3 px-6 md:py-5 md:px-11'>More Work</Link>
                    </div>
                </div>
                <div className="bg-cyan w-full h-1/2 absolute bottom-0 -z-10"></div>
            </div>
            <div className="section_5 contact bg-main py-20">
                <div className="w-5/6 lg:w-4/6 m-auto">
                    <div className="grid grid-cols-5 gap-10 lg:gap-15">
                        <motion.div
                            initial={{
                                y: -100,
                                opacity: 0
                            }}
                            whileInView={{
                                y: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.5
                            }}
                            viewport={{
                                once: true
                            }}
                            className="col-span-5 md:col-span-2 text-white ">
                            <span className="bg-gray-light bg-opacity-10 p-1 px-2 border-l-4 border-l-white text-sm ">Contact</span>
                            <h2 className="text-3xl font-semibold my-2">Get in touch with us</h2>
                            <p className="font-Krub text-sm font-medium leading-6">Leverage agile frameworks to provide a robust synopsis for strategy foster collaborative thinking to further the overall value.</p>
                            <div className="flex items-center gap-4 my-4">
                                <div className="text-main bg-white rounded-full p-3">
                                    <CiMail size={20} />
                                </div>
                                <div className="text-sm font-Krub font-medium">
                                    <p>Email</p>
                                    <span>secureTech@gmail.com</span>
                                </div>
                            </div>
                            <div className="flex items-center gap-4 my-4">
                                <div className="text-main bg-white rounded-full p-3">
                                    <PiPhoneThin />
                                </div>
                                <div className="text-sm font-Krub font-medium">
                                    <p>Call Us</p>
                                    <span className="">(971) 112 365 489</span>
                                </div>
                            </div>
                            <div className="flex items-center gap-4 my-4">
                                <div className="text-main bg-white rounded-full p-3">
                                    <CiClock2 />
                                </div>
                                <div className="text-sm font-Krub font-medium">
                                    <p>Mon - Fry 8.30 - 18.00</p>
                                    <span>Saturday, Sunday Closed</span>
                                </div>
                            </div>
                        </motion.div>
                        <motion.div
                            initial={{
                                x: -100,
                                opacity: 0
                            }}
                            whileInView={{
                                x: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.5
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-5 md:col-span-3 grid grid-cols-1 sm:grid-cols-2 gap-3">
                            <div className="col-span-1">
                                <input type="text" className="py-4 px-5 w-full" placeholder="Your name*" />
                            </div>
                            <div className="col-span-1">
                                <input type="text" className="py-4 px-5 w-full" placeholder="Email*" />
                            </div>
                            <div className="col-span-1">
                                <input type="text" className="py-4 px-5 w-full" placeholder="Phone Number*" />
                            </div>
                            <div className="col-span-1">
                                <input type="text" className="py-4 px-5 w-full" placeholder="City*" />
                            </div>
                            <div className="col-span-1 sm:col-span-2">
                                <textarea className="w-full py-4 px-5" name="Your Message" cols="30" rows="5" placeholder="Your Message" ></textarea>
                            </div>
                            <div className="col-span-1 sm:col-span-2">
                                <button type="submit" className="bg-cyan w-fit text-sm font-krub text-dark font-semibold py-3 px-6 md:py-5 md:px-11">Submit Message</button>
                            </div>
                        </motion.div>
                    </div>
                    <div className="sponsors mt-14 grid grid-cols-2 sm:grid-cols-4">
                        <motion.div
                            initial={{
                                x: -100,
                                opacity: 0
                            }}
                            whileInView={{
                                x: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.5
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 relative border border-gray">
                            <div className="layer flex items-center justify-center p-8 h-full w-full absolute bg-gradient-to-b from-transparent to-black ">
                                <img src={studio_green_logo} alt="" />
                            </div>
                            <img src={sponser_1} alt="" />
                        </motion.div>
                        <motion.div
                            initial={{
                                x: -200,
                                opacity: 0
                            }}
                            whileInView={{
                                x: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.5
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 relative border border-gray">
                            <div className="layer flex items-center justify-center p-8 h-full w-full absolute bg-gradient-to-b from-transparent to-black ">
                                <img src={norto_logo} alt="" />
                            </div>
                            <img src={sponser_2} alt="" />
                        </motion.div>
                        <motion.div
                            initial={{
                                x: 200,
                                opacity: 0
                            }}
                            whileInView={{
                                x: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.5
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 relative border border-gray">
                            <div className="layer flex items-center justify-center p-8 h-full w-full absolute bg-gradient-to-b from-transparent to-black ">
                                <img src={points_one_logo} alt="" />
                            </div>
                            <img src={sponser_3} alt="" />
                        </motion.div>
                        <motion.div
                            initial={{
                                x: 100,
                                opacity: 0
                            }}
                            whileInView={{
                                x: 0,
                                opacity: 1
                            }}
                            transition={{
                                duration: 0.5
                            }}
                            viewport={{
                                once: true
                            }} className="col-span-1 relative border border-gray">
                            <div className="layer flex items-center justify-center p-8 h-full w-full absolute bg-gradient-to-b from-transparent to-black ">
                                <img src={out_of_the_stand_logo} alt="" />
                            </div>
                            <img src={sponser_4} alt="" />
                        </motion.div>
                    </div>
                </div>
            </div>
            <div className="section_6 blog py-20">
                <div className="content w-4/5 sm:w-2/3 lg:w-1/2 m-auto flex flex-col items-center">
                    <div className="text-center w-full border-b-2 pb-10 mt-5">
                        <span className="bg-gray-light p-1 px-2 border-l-4 border-l-main-light text-sm ">Our Blog</span>
                        <h2 className="text-3xl text-dark font-semibold my-2">Our Latest News</h2>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 py-5 border-b-2">
                        <div className="image_box col-span-1 relative flex justify-center items-center group">
                            <img src={blog_1} alt="" className="h-full w-full" />
                            <Link to="/" className="layer group-hover:opacity-70 group-hover:w-full group-hover:h-full duration-300  opacity-0 h-0 w-0 bg-main-light absolute text-white text-sm font-Krub font-semibold flex justify-center items-center">
                                Read More
                            </Link>
                        </div>
                        <div className="col-span-1  md:border-l-2 py-2 md:px-4">
                            <h3 className="text-2xl hover:text-main-light text-dark">Find out why we are a data and AI leader</h3>
                            <p className="text-Krub mt-2 text-sm text-gray">Ranked among the top providers for data and AI services, we can help you make smarter, faster business decisions.</p>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 py-5 border-b-2">
                        <div className="image_box col-span-1 relative flex justify-center items-center group">
                            <img src={blog_2} alt="" className="h-full w-full" />
                            <Link to="/" className="layer group-hover:opacity-70 group-hover:w-full group-hover:h-full duration-300  opacity-0 h-0 w-0 bg-main-light absolute text-white text-sm font-Krub font-semibold flex justify-center items-center">
                                Read More
                            </Link>
                        </div>
                        <div className="col-span-1  md:border-l-2 py-2 md:px-4">
                            <h3 className="text-2xl hover:text-main-light text-dark">Named top 10: HFS App Mod Services 2022</h3>
                            <p className="text-Krub mt-2 text-sm text-gray">We are #1 in the winners circle for Application Modernization execution, innovation, OneOffice alignment and voice of the customer criteria.</p>
                        </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 py-5 border-b-2">
                        <div className="image_box col-span-1 relative flex justify-center items-center group">
                            <img src={blog_3} alt="" className="h-full w-full" />
                            <Link to="/" className="layer group-hover:opacity-70 group-hover:w-full group-hover:h-full duration-300  opacity-0 h-0 w-0 bg-main-light absolute text-white text-sm font-Krub font-semibold flex justify-center items-center">
                                Read More
                            </Link>
                        </div>
                        <div className="col-span-1  md:border-l-2 py-2 md:px-4">
                            <h3 className="text-2xl hover:text-main-light text-dark">An Everest PEAK Matrix® Enterprise QA Leader 2022</h3>
                            <p className="text-Krub mt-2 text-sm text-gray">Cognizant ranks ahead of 32 providers as a Leader in Everest Group’s PEAK Matrix® Assessment for creating prominent market impact in Enterprise QA services.</p>
                        </div>
                    </div>
                    <Link to='/blogs' className='bg-main-light w-fit text-sm font-krub text-white py-3 px-6 md:py-5 md:px-11 mt-5'>More Blog</Link>
                </div>
            </div>
            <div className="">
                <img src={abuDubaiImg} className='w-full' alt="" />
            </div>
        </div>
    )
}

export default Home